import { SectionHeader } from 'components/ui'

export const FeesHeader = () => <SectionHeader title="fees" showSearch showIslandDropdown />
